<template>
  <div class="accept-envitation-widget">
    <!-- Project widget -->
    <div class="form-widget" v-if="isProject">
      <div class="logo">
        <img src="../assets/images/logo/new_logo.svg" alt />
      </div>
      <div class="title">Describe your participation in the project…</div>
      <div class="input-widget">
        <div class="input-group col-2" style="margin-bottom: 25px">
          <input type="text" class="dark" placeholder="Project Name" />
          <input type="text" class="dark" placeholder="Company Name" />
        </div>
        <div class="input-group col-4" style="margin-bottom: 25px">
          <input type="text" class="light" placeholder="Role" />
          <div class="range-date" style="width: 230px">
            <div class="check-label">
              <label for="curr">Current Project</label>
              <input type="checkbox" name="curr" id="curr" />
            </div>
            <datepicker :monday-first="true" placeholder="Start Date" input-class="date-field-input"
              wrapper-class="date-field"></datepicker>
            <datepicker :monday-first="true" placeholder="End Date" input-class="date-field-input"
              wrapper-class="date-field"></datepicker>
          </div>
          <input type="text" class="light" placeholder="Country" />
          <input type="text" class="light" placeholder="City" />
        </div>
        <div class="input-group col-1">
          <textarea name id cols="20" rows="5" placeholder="Description"></textarea>
        </div>
      </div>
      <div class="widget-options">
        <button class="btn-submit">Submit</button>
      </div>
    </div>
    <!-- Employement widget -->
    <div class="form-widget" v-if="!isProject">
      <div class="logo">
        <img src="../assets/images/logo/new_logo.svg" alt />
      </div>
      <div class="title">Describe your participation in the employment…</div>
      <div class="input-widget">
        <div class="input-group col-3" style="margin-bottom: 25px">
          <input type="text" class="dark" style="width: 300px" placeholder="Company Name" />
          <input type="text" class="light" placeholder="Country" />
          <input type="text" class="light" placeholder="City" />
        </div>
        <div class="input-group col-2" style="margin-bottom: 25px">
          <input type="text" class="light" placeholder="Role" />
          <div class="range-date">
            <div class="check-label">
              <label for="curr">Current Employment</label>
              <input type="checkbox" name="curr" id="curr" />
            </div>
            <datepicker :monday-first="true" placeholder="Start Date" input-class="date-field-input"
              wrapper-class="date-field"></datepicker>
            <datepicker :monday-first="true" placeholder="End Date" input-class="date-field-input"
              wrapper-class="date-field"></datepicker>
          </div>
        </div>
        <div class="input-group col-1">
          <textarea name id cols="20" rows="5" placeholder="Description"></textarea>
        </div>
      </div>
      <div class="widget-options">
        <button class="btn-submit">Submit</button>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
export default {
  name: "accept-envitation",
  components: { Datepicker },
  props: [],
  data: () => {
    return {
      isProject: false,
    };
  },
  mounted() { },
  methods: {},
};
</script>
<style lang="scss" scoped>
.accept-envitation-widget {
  display: flex;
  justify-content: center;
  background: #efefef;
  min-height: 100vh;
  padding-top: 90px;

  .form-widget {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    $column-space: 20px;
    width: 800px;
    padding-top: $column-space;
    height: 600px;

    .logo {
      margin-bottom: 30px;

      img {
        width: 80px;
      }
    }

    .title {
      color: #1ba5a4;
      font-size: 30px;
      font-family: "Nunito", sans-serif;
      margin-bottom: $column-space;
    }

    .input-widget {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
      margin-bottom: $column-space;

      .input-group {
        display: grid;
        grid-column-gap: 20px;

        input.dark {
          height: 47px;
          background: #efefef 0% 0% no-repeat padding-box;
          border-radius: 5px;
          padding: 0px 20px;
          color: #000;
          font-family: "Nunito", sans-serif;
          outline: none;
        }

        input.dark::placeholder {
          font-weight: 800;
        }

        input.light {
          height: 47px;
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 2px 6px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 0px 20px;
          color: #000;
          font-family: "Nunito", sans-serif;
          outline: none;
        }

        textarea {
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 3px 3px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 10px;
          outline: none;
        }

        .range-date {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: auto auto;
          height: 47px;
          background: #ffffff 0% 0% no-repeat padding-box;
          box-shadow: 0px 2px 6px #00000029;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 4px 0px;
          padding-right: 10px;
          position: relative;

          .date-field {
            background: #efefef;
            margin-left: 5px;
            height: 36px;
            border-radius: 5px;
            padding: 8px 10px;
            width: 100%;

            .date-field-input {
              width: 100% !important;
            }
          }

          .check-label {
            position: absolute;
            z-index: 999;
            top: -19px;
            right: 0px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            label {
              width: calc(100% - 10px);
              text-align: right;
            }

            input {
              width: 10px;
              margin-left: 5px;
            }
          }
        }
      }

      .input-group.col-1 {
        grid-template-columns: auto;
      }

      .input-group.col-2 {
        grid-template-columns: auto auto;
      }

      .input-group.col-3 {
        grid-template-columns: auto auto auto;
      }

      .input-group.col-4 {
        grid-template-columns: auto auto auto auto;

        input {
          width: 147px;
        }
      }
    }

    .widget-options {
      margin-bottom: $column-space;

      .btn-submit {
        width: 234px;
        height: 48px;
        background: #1885ad 0% 0% no-repeat padding-box;
        border-radius: 5px;
        color: #fff;
        font-family: "Nunito", sans-serif;
        font-weight: 800;
      }
    }
  }
}
</style>
<style lang="scss">
.date-field {
  background: #efefef;
  margin-left: 5px;
  height: 36px;
  border-radius: 5px;
  padding: 8px 10px;
  width: 100%;

  .date-field-input {
    width: 100% !important;
  }
}
</style>
